import React, { useEffect, useState } from "react";
import {
  Card, Tag, Avatar, Spin, Modal, Upload,
  Button, Input, message, Form
} from "antd";
import {
  CameraOutlined, UploadOutlined, EditOutlined
} from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import axios from "axios";

const ProfileOperations = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const [editOpen, setEditOpen] = useState(false);
  const [form] = Form.useForm();

  const token = localStorage.getItem("token");

  // ✅ FETCH PROFILE
  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/user/instructor/profile/view`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        setProfile(res.data.data);
        localStorage.setItem("profilePhotoUrl", res.data.data.ProfilePhotoUrl);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (profile) {
      form.setFieldsValue({
        PhoneNumber: profile.PhoneNumber,
        Country: profile.Country,
      });
    }
  }, [profile]);

  // ✅ PHOTO UPLOAD (SAME API)
  const handleUpload = async () => {
    if (!file) return message.error("Select image");

    const formData = new FormData();
    formData.append("ProfilePhoto", file);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/upload-profile-photo`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        message.success("Photo updated");
        setIsPhotoModalOpen(false);
        setFile(null);
        setPreview(null);
        fetchProfile();
      }
    } catch {
      message.error("Upload failed");
    }
  };

  // ✅ UPDATE BASIC INFO
  const handleUpdate = async (values) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/user/operations/update-basic`,
        values,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        message.success("Updated successfully");
        setEditOpen(false);
        fetchProfile();
      }
    } catch {
      message.error("Update failed");
    }
  };

  if (loading) return <Spin className="mt-20" />;

  return (
    <div className="p-6 mx-auto space-y-6 max-w-7xl">

      {/* ================= HEADER ================= */}
      <Card className="border-0 shadow-md rounded-3xl">

        <div className="flex items-center justify-between">

          <div className="flex items-center gap-5">

            {/* AVATAR */}
            <div className="relative group">
              <div className="p-[2px] rounded-full bg-gradient-to-r from-blue-500 to-purple-500">
                <Avatar
                  size={90}
                  src={profile.ProfilePhotoUrl}
                  onClick={() => setIsPhotoModalOpen(true)}
                  className="bg-white cursor-pointer"
                >
                  {profile.FullName?.[0]}
                </Avatar>
              </div>

              <div
                onClick={() => setIsPhotoModalOpen(true)}
                className="absolute inset-0 flex items-center justify-center rounded-full opacity-0 cursor-pointer bg-black/60 group-hover:opacity-100"
              >
                <CameraOutlined className="text-white" />
              </div>
            </div>

            {/* INFO */}
            <div>
              <h1 className="text-2xl font-semibold">
                {profile.FullName}
              </h1>

              <p className="text-gray-500">{profile.Email}</p>

              <div className="flex gap-2 mt-2">

                <Tag color="blue">{profile.Role}</Tag>

                <Tag
                  color={profile.OperationsStatus === "ACTIVE" ? "green" : "red"}
                >
                  {profile.OperationsStatus}
                </Tag>

              </div>
            </div>
          </div>

          <Button onClick={() => setIsPhotoModalOpen(true)}>
            Update Photo
          </Button>

        </div>
      </Card>

      {/* ================= BASIC ================= */}
     {/* BASIC INFO */}
                <Card
            title={
              <div>
                <h2 className="text-lg font-semibold text-slate-900">
                  Basic Information
                </h2>
                <p className="text-xs text-gray-500">
                  Your personal contact details
                </p>
              </div>
            }
            className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-orange-50 to-white"
          >
          
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          
              {/* PHONE */}
              <div className="p-4 bg-white border shadow-sm rounded-xl border-sky-100">
                <p className="text-xs font-medium tracking-wide uppercase text-sky-600">
                  Phone Number
                </p>
          
                <p className="mt-1 text-sm font-semibold text-slate-800">
                  {profile?.PhoneNumber || (
                    <span className="text-red-500">Not Provided</span>
                  )}
                </p>
              </div>
          
              {/* COUNTRY */}
              <div className="p-4 bg-white border border-blue-100 shadow-sm rounded-xl">
                <p className="text-xs font-medium tracking-wide text-blue-600 uppercase">
                  Country
                </p>
          
                <p className="mt-1 text-sm font-semibold text-slate-800">
                  {profile?.Country || (
                    <span className="text-red-500">Not Provided</span>
                  )}
                </p>
              </div>
          
            </div>
          
          </Card>

      {/* ================= OPERATIONS ACTIVITY ================= */}
<Card
  bordered={false}
  className="mb-6 shadow-md rounded-2xl"
  title={
    <h2 className="text-lg font-semibold tracking-wide text-slate-800">
      Operations Activity
    </h2>
  }
>
  <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

    {/* COURSES OPERATING */}
    <div className="relative p-5 transition-all duration-300 border shadow-sm bg-gradient-to-br from-indigo-50 to-white rounded-2xl hover:shadow-lg">

      {/* Label */}
      <p className="mb-1 text-xs font-medium tracking-wide text-indigo-500 uppercase">
        Courses Operating
      </p>

      {/* Value */}
      <h3 className="text-3xl font-bold text-slate-900">
        {profile.CoursesOperating || 0}
      </h3>

      {/* Subtle Indicator */}
      <div className="absolute flex items-center justify-center w-10 h-10 bg-indigo-100 rounded-full top-4 right-4">
        <span className="text-lg font-bold text-indigo-600">📚</span>
      </div>

      {/* Bottom Accent Line */}
      <div className="absolute bottom-0 left-0 w-full h-1 rounded-b-2xl bg-indigo-400/60"></div>

    </div>

  </div>
</Card>

       {/* ================= PHOTO MODAL ================= */}
      <Modal
        open={isPhotoModalOpen}
        onCancel={() => setIsPhotoModalOpen(false)}
        footer={null}
        centered
        width={500}
        title={
          <span className="text-lg font-semibold text-slate-800">
            Update Profile Photo
          </span>
        }
      >
      
        <div className="space-y-5">
      
          {/* NAME */}
          <div>
            <p className="text-sm font-medium text-gray-500">Full Name</p>
            <Input value={profile?.FullName} disabled className="h-10 mt-1" />
          </div>
      
          {/* EMAIL */}
          <div>
            <p className="text-sm font-medium text-gray-500">Email</p>
            <Input value={profile?.Email} disabled className="h-10 mt-1" />
          </div>
      
          {/* UPLOAD */}
          <div>
            <p className="mb-2 text-sm font-medium text-gray-500">
              Upload Profile Photo
            </p>
      
            <ImgCrop aspect={1} rotationSlider>
              <Upload
                beforeUpload={(file) => {
                  const isImage = file.type.startsWith("image/");
                  if (!isImage) {
                    message.error("Only image files are allowed");
                    return false;
                  }
      
                  setFile(file);
                  setPreview(URL.createObjectURL(file));
                  return false;
                }}
                showUploadList={false}
              >
                <Button block icon={<UploadOutlined />} className="h-11">
                  Select Image
                </Button>
              </Upload>
            </ImgCrop>
          </div>
      
          {/* PREVIEW */}
          {preview && (
            <div className="flex justify-center mt-3">
              <img
                src={preview}
                alt="preview"
                className="object-cover w-32 h-32 border rounded-full shadow-sm"
              />
            </div>
          )}
      
          {/* SUBMIT */}
          <Button
            type="primary"
            block
            className="mt-2 h-11"
            onClick={handleUpload}
          >
            Update Profile Photo
          </Button>
      
        </div>
      
      </Modal>

      {/* ================= EDIT MODAL ================= */}
      <Modal open={editOpen} onCancel={() => setEditOpen(false)} footer={null}>

        <Form form={form} layout="vertical" onFinish={handleUpdate}>

          <Form.Item name="PhoneNumber" label="Phone">
            <Input />
          </Form.Item>

          <Form.Item name="Country" label="Country">
            <Input />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Update
          </Button>

        </Form>

      </Modal>

    </div>
  );
};

export default ProfileOperations;